import { render } from "./AllClassMates.vue?vue&type=template&id=64943518"
import script from "./AllClassMates.vue?vue&type=script&lang=js"
export * from "./AllClassMates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__